const defaultRiskLevels = [
  {
    id: 0,
    value: "Low",
  },
  {
    id: 1,
    value: "Medium",
  },
  {
    id: 2,
    value: "High",
  },
];

const useObservationMapping = () => {
  const complianceMap = (item) => {
    const num = parseInt(item);
    if (num === 0) return "No";
    if (num === 1) return "Yes";
    return "";
  };

  const riskMap = (item, riskLevels = []) => {
    const num = parseInt(item);
    const found = Array.isArray(riskLevels)
      ? riskLevels.find(({ id }) => parseInt(id) === num)
      : undefined;

    if (found) return found?.value;
    if (num === 0) return "Low";
    if (num === 1) return "Medium";
    if (num === 2) return "High";
    if (num === 3) return "Critical";
    return "";
  };

  const conformityLevelMap = (item, conformity = []) => {
    const num = parseInt(item);
    const found = Array.isArray(conformity)
      ? conformity.find(({ id }) => parseInt(id) === num)
      : undefined;
    if (found) return found?.value;
    if (num === 0) return "Fully Meets";
    if (num === 1) return "Substantial Conformity";
    if (num === 2) return "Partial Conformity";
    if (num === 3) return "Does Not Meet";
    if (num === 4) return "Not Applicable";
    return "";
  };

  const conformityLevelPoints = (item, conformity = []) => {
    const num = parseInt(item);
    const found = Array.isArray(conformity)
      ? conformity.find(({ id }) => parseInt(id) === num)
      : undefined;
    if (found) return found?.points;
    return "";
  };

  const getRiskLevel = (riskLevels) => {
    if (!Array.isArray(riskLevels)) return defaultRiskLevels;
    if (riskLevels.length === 0) return defaultRiskLevels;
    return riskLevels;
  };

  return {
    riskMap,
    getRiskLevel,
    complianceMap,
    conformityLevelMap,
    conformityLevelPoints,
  };
};

export default useObservationMapping;
